import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {hideConfirmModal, setConfirmModalActing} from "../../../store/actions/display";
import {FormAsyncButton} from "../../controls/buttons/AsyncButton";

class ConfirmModal extends Component {
    toggle = () => {
        this.props.hideConfirmModal();
    };

    onConfirm = () => {
        this.props.onConfirm();
        this.props.modal.onConfirm();
    };

    render() {
        const {modal} = this.props;
        return modal ? (
            <Modal isOpen={!!modal} toggle={this.toggle}>
                <ModalHeader toggle={this.toggle}>{modal.title}</ModalHeader>
                <ModalBody>
                    {modal.body}
                </ModalBody>
                <ModalFooter>
                    <Button className="float-left" color="default" onClick={this.toggle}>{modal.cancelText || "Cancel"}</Button>
                    <FormAsyncButton acting={modal.acting} color={modal.confirmColor} onClick={this.onConfirm}>
                        {modal.confirmText || "Confirm"}
                    </FormAsyncButton>
                </ModalFooter>
            </Modal>
        ) : null;
    }
}

ConfirmModal.propTypes = {
    id: PropTypes.number.isRequired
};

const mapStateToProps = (state, props) => ({
    modal: state.display.modals.find((i) => i.id === props.id)
});

const mapDispatchToProps = (dispatch, props) => {
    return {
        hideConfirmModal() {
            return dispatch(hideConfirmModal(props.id));
        },
        onConfirm() {
            return dispatch(setConfirmModalActing(props.id, true));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmModal);


// WEBPACK FOOTER //
// ./src/components/display/Modals/ConfirmModal.js